import { render, staticRenderFns } from "./ProfileGridItem.vue?vue&type=template&id=2a21f5b7&"
import script from "./ProfileGridItem.vue?vue&type=script&lang=js&"
export * from "./ProfileGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports